module.exports = __webpack_public_path__ + "img/ปลาแฮร์ริง.94d5d0af.png";